import { render, staticRenderFns } from "./BatchSamplesBatchSelection.vue?vue&type=template&id=313cfa7b&scoped=true"
import script from "./BatchSamplesBatchSelection.vue?vue&type=script&lang=js"
export * from "./BatchSamplesBatchSelection.vue?vue&type=script&lang=js"
import style0 from "./BatchSamplesBatchSelection.vue?vue&type=style&index=0&id=313cfa7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313cfa7b",
  null
  
)

export default component.exports